//import Swal from "sweetalert2";
//import Vue from "vue";
import { getLiveCities, getLiveCity, deleteLiveCity, saveLiveCity, updateLiveCity} from '@/services/modules/liveCity'

export const state = {
  liveCities: []
}

export const mutations = {
  setLiveCities (state, data) {
    state.liveCities = data.data
  }
}

export const getters = {
  getLiveCities (state) {
    return state.liveCities
  }
}

export const actions = {
  async getLiveCities (context) {
    // eslint-disable-next-line no-unused-expressions
  
    const result = await getLiveCities()
    context.commit('setLiveCities', result.data)
    return result.data
  },
  
  async saveLiveCity (context, { payload }) {
    const result = await saveLiveCity(payload)
    if (result.data.status) {
      context.dispatch('getLiveCities')
    }
    return result.data
  },
  
  async updateLiveCity (context, { payload }) {
    const result = await updateLiveCity(payload)
    if (result.data.status) {
      context.dispatch('getLiveCities')
    }
    return result.data
  },
  
  async deleteLiveCity (context, { cityId }) {
    const result = await deleteLiveCity(cityId)
    if (result.data.status) {
      context.dispatch('getLiveCities')
    }
    return result.data
  },
  async getLiveCity (context, { cityId }) {
    const result = await getLiveCity(cityId)
    return result.data
  }
}
